export default (percentage: number) => {
  return percentage;
};
